// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IBranchApi,
  IBranchApiRequest,
  IBranchApiGetDropdownAttrs,
  IBranchApiSaveAttrs,
  IBranchApiListResponse,
  IBranchApiDetailResponse,
  IBranchApiDropdownResponse,
  IBranchApiNullResponse,
  IBranchApiGetListAttrs,
  IBranchApiGetDetailAttrs,
} from 'interfaces/back-office/master/branch/branch-api.interface'
// eslint-disable-next-line
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class BranchApi extends BaseApi<IBranchApi> implements IBranchApiRequest {
  readonly url = ApiConstant.MASTER_BRANCH_URL
  private branchUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get branch list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IBranchApiGetListAttrs} payload
   *
   * @return {Promise<IBranchApiListResponse>} Promise<IBranchApiListResponse>
   */
  async masterBranch_getList(payload: IBranchApiGetListAttrs): Promise<IBranchApiListResponse> {
    return this.POST(`${this.branchUrl}/list`, payload.body, { ...payload.requestConfig })
  }

  /**
   * @description Get detail branch
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IBranchApiGetDetailAttrs} payload
   *
   * @return {Promise<IBranchApiDetailResponse>} Promise<IBranchApiDetailResponse>
   */
  async masterBranch_getDetail(payload: IBranchApiGetDetailAttrs): Promise<IBranchApiDetailResponse> {
    return this.POST(`${this.branchUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Save branch
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IBranchApiSaveAttrs} payload
   *
   * @return {Promise<IBranchApiNullResponse>} Promise<IBranchApiNullResponse>
   */
  async masterBranch_save(payload: IBranchApiSaveAttrs): Promise<IBranchApiNullResponse> {
    const requestPayload: IBaseApiRequestPayload = {
      method: 'POST',
      url: payload.params?.id ? `${this.branchUrl}/update/${payload.params.id}` : `${this.branchUrl}/create`,
    }
    return this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })
  }

  /**
   * @description Get company list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IBranchApiGetDropdownAttrs} payload
   *
   * @return {Promise<IBranchApiDropdownResponse>} Promise<IBranchApiDropdownResponse>
   */
  async masterBranch_getDropdown(payload: IBranchApiGetDropdownAttrs): Promise<IBranchApiDropdownResponse> {
    return this.POST(`${this.branchUrl}/dropdown`, {}, { ...payload.requestConfig })
  }
}
